







import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import UserSearchListTable from '@/components/user/UserSearchListTable.vue'

// Models
import UserModel from '@/_models/UserModel'
import { EUserType } from '@/_enums/user_type'
// Mixins
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'
import IndoorOutdoorMixin from '@/components/mixins/IndoorOutdoorMixin.vue'

// Others
import { alertUserChangeLocation } from '@/_utils/card-alert'
import { Filter } from '@/_utils/filter'
import { isGPSMode } from '@/_utils/card'

@Component({
  components: {
    UserSearchListTable,
  },
})
export default class UserSearchList extends mixins(TableSortMixin, IndoorOutdoorMixin) {
  // data
  @Prop() isParentBlinkRefresh!: boolean
  filterUtilTableSort: any = new Filter('filter_user_search_list_sort')
  filterUtilPage: any = new Filter('filter_user_search_page_202011')
  isFirstLoadingUsers: boolean = true

  // computed
  get isLoading(): boolean {
    return this.$store.state.beacons.loading || this.isFirstLoadingUsers
  }

  get canGotoOutdoorUser(): boolean {
    return !this.isCardOff(this.selectedUser) && !this.hasAlert(this.selectedUser)
  }

  get canGotoOutdoorList(): boolean {
    this.checkedRows = this.checkedRows.filter((user: UserModel) => {
      return this.canCheckUser(user)
    })

    if (!this.filteredUsers || !this.checkedRows.length) {
      return false
    }

    for (const user of this.filteredUsers) {
      if (this.canCheckUser(user)) {
        return true
      }
    }

    return false
  }

  get filteredUsers(): UserModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.users) {
      return []
    }

    return this.users.filter((item: UserModel): boolean => {
      if (!item[targetField]) {
        return false
      }

      const searchKey =
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.pageFilters.searchQuery.toString().toLowerCase()) !== -1

      const validPeople = item.user_type === 'people' && this.isCheckedPeople
      const validThing = item.user_type === 'things' && this.isCheckedThings

      return searchKey && (validPeople || validThing)
    })
  }

  onTableRowDoubleClick(user: UserModel) {
    if (user.current_location_name) {
      this.handleGotoIndoorOutDoor(isGPSMode(user) ? 'outdoor' : 'indoor')
    }
  }

  @Watch('selectedUser')
  async selectedChanged() {
    if (this.selectedUser._id && !this.canGotoOutdoorUser) {
      this.selectedUser = new UserModel()
    }

    this.checkedRowsSyncWidget()
  }

  @Watch('users')
  async usersChanged(newList, oldList) {
    alertUserChangeLocation(this, newList, oldList)
  }

  @Watch('isParentBlinkRefresh')
  onParentBlinkRefresh() {
    this.isBlinkRefresh = !!this.isParentBlinkRefresh
  }

  checkedRowsSyncWidget() {
    if (!!this.widgetOptions && this.selectedUser._id) {
      const oldIndex = this.checkedRows.findIndex(item => item._id === this.selectedUser._id)
      if (oldIndex > -1) {
        this.checkedRows.splice(oldIndex, 1)
      } else {
        this.checkedRows.push(this.selectedUser)
      }

      this.$emit('onSelectedUser', this.checkedRows)
    }
  }

  handleGotoOutDoorList(): void {
    if (!this.canGotoOutdoorList) {
      return
    }

    this.filterUtilCheckedRows.save(this.checkedRows)
    if (this.checkIsAllRowsHaveSameFloor()) {
      this.handleGotoIndoor()
      return
    }

    if (!this.selectedUser._id) {
      this.$router
        .push({
          name: 'outdoor_type_bound',
        })
        .catch(error => false)
    } else {
      this.handleGotoIndoorOutDoor('outdoor_user')
    }
  }

  checkIsAllRowsHaveSameFloor() {
    const floorIds: string[] = []
    return this.checkedRows.every(item => {
      if (floorIds.length > 1 && !floorIds.includes(item.current_floor_id)) {
        return false // break loop
      }

      // exist value can be pushed
      if (item.current_floor_id) {
        floorIds.push(item.current_floor_id)
      } else {
        return false
      }

      return true // continue loop
    })
  }

  handleGotoIndoor(): void {
    const route: any = {
      name: 'indoor',
      params: {},
    }
    if (this.checkedRows.length === 1) {
      route.params.user_id = this.checkedRows[0]._id
    }

    this.$router.push(route).catch(error => false)
  }

  handleGotoIndoorOutDoor(nameRoute: string): void {
    if (!this.canGotoOutdoorUser) {
      return
    }

    this.$router
      .push({
        name: nameRoute,
        params: { user_id: this.selectedUser._id },
      })
      .catch(error => false)
  }

  // methods
  beforeDestroy() {
    this._isDestroyed = true
    this.$store.dispatch('users/clearSetTimeOut')
    clearTimeout(this.refreshTimer)
    this.filterUtilPage.save(this.pageFilters)
    this.filterUtilCheckedRows.save(this.checkedRows)
  }

  loadWidgetProcess() {
    this.isFirstLoadingUsers = false

    if (this.widgetOptions.user_type !== EUserType.all) {
      this.isCheckedPeople = this.widgetOptions.user_type === EUserType.people
      this.isCheckedThings = this.widgetOptions.user_type === EUserType.thing
    }

    this.pageFilters.selectedFilter = this.widgetOptions?.filter_text?.selected ?? ''
    this.pageFilters.searchQuery = this.widgetOptions?.filter_text?.value ?? ''
  }

  async loadUserDatasPage() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.checkedRows = this.filterUtilCheckedRows.get([])

    await this.$store.dispatch('settings/getFromLocal')
    await this.$store.dispatch('cards/getAll', { card_type: 'all' })
    await this.$store.dispatch('beacons/getAll')

    this.isFirstLoadingUsers = true
    if (!this.users.length) {
      await this.$store.dispatch('users/getAll', { floor: 'all' })
    }

    this.isFirstLoadingUsers = false
    this.refreshUsersInFloor()
  }

  // After page created
  async created() {
    if (!!this.widgetOptions) {
      return this.loadWidgetProcess()
    }

    await this.loadUserDatasPage()
  }
}
